import axiosOrders from '../../axios/quickOrders'
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';

const JSEncrypt = require( 'node-jsencrypt' );

const state = {

    // taxRate              : 0.07, // no longer used. Can be deleted. Tax is now item-specific
    orderTip                : 0.00,
    tip                     : localStorage.getItem( 'tip' ) || 0.00,
    tipValue                : 0.2,
    currentTab              : JSON.parse( localStorage.getItem( 'cart' ) ) || [],
    orderError              : null,
    saveCard                : false,
    cloverOrderId           : '',
    quickOrderId            : '',
    orderNote               : JSON.parse( localStorage.getItem( 'updateNote' ) ) || '',
    thisOrderNumber         : '',
    thisInternalOrderNumber : '',
    currentOrderSubmitted   : JSON.parse( localStorage.getItem( 'cartSubmit' ) ) || [],
    orderWasChanged         : false,
    isLoading               : false,
    delivery                : JSON.parse( localStorage.getItem( 'DeliverySelected' ) ) || [],
    otherFees               : localStorage.getItem( 'otherFees' ) || 0.00,
    deliveryFee             : 0.00
};

const mutations = {

    toggleSaveCard     : state => state.saveCard = !state.saveCard,
    setOrderWasChanged : state => state.orderWasChanged = !state.orderWasChanged,
    addItem( state, item ){

        item.id = Math.random().toString( 36 ).substr( 2, 9 );
        state.currentTab.push( item );
        localStorage.setItem( 'cart', JSON.stringify( state.currentTab ) );
    },
    removeItem( state, id ){

        const items = [ ...state.currentTab ]; // a little 'immutable' way of changing state... probably..
        const newList = items.filter( function( item ){

            return item.id != id;
        });

        //console.log("list",newList);
        state.currentTab = newList;
        localStorage.setItem( 'cart', JSON.stringify( newList ) );
    },
    addCurrentOrderSubmitted( state, order ){
        state.currentOrderSubmitted = order;
        localStorage.setItem( 'cartSubmit', JSON.stringify( state.currentOrderSubmitted ) );
    },
    saveEditing( state, data ){

        state.currentTab = [

            ...state.currentTab.filter( item => item.id !== data.id )
        ];
        state.currentTab.push( data );
        localStorage.setItem( 'cart', JSON.stringify( state.currentTab ) );
    },
    clearTab( state ){

        state.currentTab = [];
        localStorage.removeItem( 'cart' );
        state.currentOrderSubmitted = [];
        localStorage.removeItem( 'cartSubmit' );
        localStorage.removeItem( 'updateNote' );
        localStorage.removeItem( 'tip' );
        localStorage.removeItem( 'otherFees' );
    },
    setOtherFees( state, values ){
        console.log('setOtherFees')
        var otherFees = parseFloat(values.rmtFee) + parseFloat(values.processingFee) + parseFloat(values.deliveryNetworkFee)
        console.log(otherFees)
        localStorage.setItem( 'otherFees', otherFees );
        state.otherFees = otherFees
    },
    setFees( state, value ){
        console.log('setFees')
        localStorage.setItem( 'otherFees', value );
    },
    setDeliveryFee( state, value ){
        console.log('setDeliveryFee')
        state.deliveryFee = parseFloat(value)
        console.log(state.deliveryFee)
    },
    updateTab( state, newTab ){

        state.currentTab = newTab;
        localStorage.setItem( 'cart', JSON.stringify( newTab ) );
    },
    saveCloverOrderId( state, cloverOrderId ){
        state.cloverOrderId = cloverOrderId;
    },
    saveQuickOrderId( state, quickOrderId ){
        state.quickOrderId = quickOrderId;
    },
    removeCloverOrderId( state ){
        state.cloverOrderId = '';
    },
    removeOrderWasChanged( state ){
        state.orderWasChanged = false;
    },
    setTipValue( value ){
        console.log("setTipValue")
        console.log(value)
        localStorage.setItem( 'tip', parseFloat(value.orderTip) );
    },
    updateTip               : ( state, value ) => state.orderTip = parseFloat( value || 0 ).toFixed( 2 ),
    orderError              : ( state, value ) => state.orderError = value,
    toggleTab               : state => state.tabOpen = !state.tabOpen,
    updateNote              : ( state, value ) => state.orderNote = value,
    toggleSaveCard          : state => state.saveCard = !state.saveCard,
    updateTipValue          : ( state, value ) => state.tipValue = value,
    thisOrderNumber         : ( state, value ) => state.thisOrderNumber = value,
    thisInternalOrderNumber : ( state, value ) => state.thisInternalOrderNumber = value,
    setIsLoading            : ( state, value ) => state.isLoading = value,
};

const actions = {

    getOrderTotal( { getters} ){
        console.log('getOrderTotal... ');
        console.log("refreshing orderTotal...");
        let deliverySelected = JSON.parse( localStorage.getItem( 'DeliverySelected' ) );

        if ( deliverySelected !== null ) {
            console.log("refreshing page with deliverySelected true case");
        
            let deliveryType = JSON.parse( localStorage.getItem( 'DeliverySelected' ) ).deliveryType;
            let fullDelivery = JSON.parse( localStorage.getItem( 'currentLocation' ) ).fullDelivery;
    
            if (deliveryType == 'FullDelivery' && fullDelivery !== false) {
                console.log("FullDelivery case getOrderTotal");
                let deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
                return (parseFloat(getters.getTax) + parseFloat(getters.getDeliveryOtherFee) + getters.getCost + parseFloat(deliveryFee) + parseFloat(getters.orderTip) - getters.getPromotionCard  ).toFixed( 2 );
            }
        } 
        return (parseFloat(getters.getTax) + getters.getCost + parseFloat(getters.orderTip) - getters.getPromotionCard  ).toFixed( 2 );
    },
    addItem( { commit }, item ){

        commit( 'addItem', item );
    },
    removeItem( { commit, getters, dispatch, rootGetters }, item ){
        commit( 'removeItem', item.id );
        //console.log('currentab va', getters.currentTab.length);
        if (getters.currentTab.length < 1) {
            if (rootGetters.currentRoute.name == 'order-tab') dispatch('cards/clearCurrentCard', null, { root: true });
        }
        dispatch( 'getOrderFees' );
        dispatch( 'setTip', getters.tipValue );
    },
    saveEditing( { commit, getters, dispatch, rootGetters }, item ){

        commit( 'saveEditing', item );
        if( rootGetters.previousRoute.name == 'order-tab' ){

            router.push({

                name : 'order-tab',
                params : { slug : rootGetters[ 'merchant/merchantSlug' ] }
            });
        }
        dispatch( 'orderMenu/clearEditing', null, { root: true } );
    },
    clearTab( { commit, getters, dispatch, rootGetters } ){
        //console.log("im cleartab");
        commit( 'clearTab' );
        if( rootGetters.currentRoute.name == 'order-tab' ) commit( 'updateTip', 0 );
        if (rootGetters.currentRoute.name == 'order-tab') dispatch('cards/clearCurrentCard', null, { root: true } );
    },
    resetError( {commit} ){
        commit( 'orderError', null );
    },
    getOrderFees( { commit, getters, dispatch, rootGetters} ){
        let uuid = JSON.parse( localStorage.getItem( 'activeOrder' ) ).uuid;
        console.log( 'uuid: ' + uuid );

        const data = {
            uuid: uuid,
            subTotal: getters.getCost
        }

        console.log('Data to Send to Jupiter Backend')
        console.log(data)

        let merchantId = rootGetters[ 'merchant/currentMerchant' ].merchantId
        let locationId = rootGetters[ 'merchant/currentLocation' ].locationId

        commit( 'setIsLoading', true );

        axiosOrders({

            method: 'post',
            url: '/orderFees/' + merchantId + '/' + locationId,
            data: qs.stringify( data )
        }).then( res => {
            console.log('___CALL HERE___')
            console.log( 'Response jupiter with Order fees: ', res.data );

            if ( res.data.responseCode == 100 ) {
                commit( 'setIsLoading', false );
                console.log('getting a DeliveryFee...');
                console.log(res.data.data);
                commit( 'setDeliveryFee', res.data.data.priorityDeliveryFee)
                commit( 'setOtherFees', res.data.data)

                const order = {
                    uuid: uuid,
                    deliveryFee: res.data.data.priorityDeliveryFee
                };
    
                dispatch( 'orders/setActiveOrder', order, { root: true } );
            } else {
                console.log("No response jupiter with delivery fee..")
                commit( 'setIsLoading', false );
                commit( 'orderError', null );
                commit( 'clearTab' );
                router.replace( { name : 'order-delivery-failure' } );
            }
        }).catch( err => {
            commit( 'setIsLoading', false );
            commit( 'orderError', null );
            commit( 'clearTab' );
            router.replace( { name : 'order-delivery-failure' } );
        });
    },
    submitOrder( { commit, getters, dispatch, rootGetters }, encryptedPaymentDetails ){

        if( parseInt( rootGetters[ 'merchant/currentLocation' ].acceptingOrders ) == 1 ){

            commit( 'setIsLoading', true );

            console.log('We are getting cloverOrderId::: ', getters.cloverOrderId);
            console.log('bonus  ', encryptedPaymentDetails.bonus);

            let formattedTab = [];
            state.currentTab.forEach( item => {

                if( item.available != 0 ){

                    let newModList = [];
                    item.modifiers.forEach( mod => { // strip out the modifier metadata, only send the modId to the API

                        let splitMod = mod.split( "_" );
                        newModList.push( splitMod[ 3 ] );
                    });
                    formattedTab.push({

                        ...item,
                        modifiers : newModList
                    });
                }
            });

            var deliveryFee = 0;
            var uuid = JSON.parse( localStorage.getItem( 'activeOrder' ) ).uuid;

            let deliverySelected = JSON.parse( localStorage.getItem( 'DeliverySelected' ) );

            if ( deliverySelected !== null ) {

                let deliveryType = JSON.parse( localStorage.getItem( 'DeliverySelected' ) ).deliveryType;
                let fullDelivery = JSON.parse( localStorage.getItem( 'currentLocation' ) ).fullDelivery;

                if (deliveryType == 'FullDelivery' && fullDelivery !== false) {
                    console.log('Delivery Fee on submitOrder');
                    deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
                }
            }

            axiosOrders({

                method: 'post',
                url: '/createOrder',
                data: qs.stringify({

                    merchantId                  : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                    merchantLocationId          : rootGetters[ 'merchant/currentLocation' ].locationId,
                    items                       : window.btoa( JSON.stringify( formattedTab ) ),
                    payment                     : encryptedPaymentDetails.encryptedData ? encryptedPaymentDetails.encryptedData : null,
                    tax                         : getters.getTax,
                    tip                         : state.orderTip,
                    quickPickupSpotId           : encryptedPaymentDetails.delivery.deliveryType == 'PickupSpot' ? encryptedPaymentDetails.delivery.quickPickupSpotId : null,
                    buildingPickupDescription   : encryptedPaymentDetails.delivery.deliveryType == 'BuildingDelivery' ? encryptedPaymentDetails.delivery.detailBuilding : null,
                    deliveryAddress1            : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressOne : null,
                    deliveryAddress2            : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressTwo : null,
                    deliveryCity                : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressCity : null,
                    deliveryState               : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressState : null,
                    deliveryZipCode             : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressZip : null,
                    deliveryCountry             : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.addressCountry : null,
                    deliveryInstructions        : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? encryptedPaymentDetails.delivery.deliveryInstructions : null,
                    hasDelivery                 : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? 1 : 0,
                    deliveryFee                 : encryptedPaymentDetails.delivery.deliveryType == 'FullDelivery' ? deliveryFee : 0,
                    saveCardOnFile              : encryptedPaymentDetails.saveCard,
                    useCardOnFile               : encryptedPaymentDetails.useCard === null ? 1 : 0,
                    orderNote                   : state.orderNote == '' ? '' : JSON.parse( localStorage.getItem( 'updateNote' ) ),
                    bonus                       : encryptedPaymentDetails.bonus,
                    subTotal                    : encryptedPaymentDetails.subTotalBefore,
                    payOnPickup                 : encryptedPaymentDetails.payOnPickup,
                    subTotalAfter               : encryptedPaymentDetails.subTotalAfter ? encryptedPaymentDetails.subTotalAfter : null,
                    uuid                        : uuid
                })
            }).then( res => {

                // let response = res.data.responseCode;
                // console.log( 'typeof response code: ', typeof response );
                console.log( 'response code: ', res.data );

                if ( res.data.responseCode == 100 ) { // order worked

                    // update phone number and wait time of merchant, just in case
                    const merch = {

                        waitTime    : res.data.quickOrderCreate.order.QuickMerchantLocation.waitTime,
                        phoneNumber : res.data.quickOrderCreate.order.QuickMerchantLocation.phoneNumber
                    };
                    dispatch( 'merchant/updateCurrentLocationAfterOrder', merch, { root: true } );

                    commit( 'setIsLoading', false );
                    commit( 'orderError', null );
                    commit( 'clearTab' );
                    commit( 'thisOrderNumber', res.data.quickOrderCreate.order.QuickOrder.externalOrderId );
                    commit( 'thisInternalOrderNumber', res.data.quickOrderCreate.order.QuickOrder.quickOrderId);
                    commit( 'removeCloverOrderId' );
                    commit( 'removeOrderWasChanged' );
                    state.cardsCached = null;
                    dispatch( 'orders/clearState', null, { root: true } );
                    dispatch( 'orderMenu/clearState', null, { root: true } );
                    dispatch( 'cards/cleanCards', null, { root: true } );
                    dispatch( 'orders/generateUuidOrder', null, { root: true } ).then( uuidOrder => {
                        console.log('uuidOrder in orderTab started again');
                        console.log(uuidOrder);
    
                        const order = {
                            uuid: uuidOrder,
                            deliveryFee: 0
                        };
    
                        dispatch( 'orders/setActiveOrder', order, { root: true } );
                    });
                    router.replace( { name : 'order-success' } );

                } else if ( res.data.responseCode == 20912 ) {

                    console.log('We are getting cloverOrderId::: ', res.data.quickOrderCreate.orderResult.externalOrderId);
                    dispatch( 'orderTab/saveCloverOrderId', res.data.quickOrderCreate.orderResult.externalOrderId, { root: true });
                    dispatch( 'orderTab/saveQuickOrderId', res.data.quickOrderCreate.order.QuickOrder.quickOrderId, { root: true });
                    
                    console.log('cards :: ', JSON.parse( localStorage.getItem( 'cart' ) ));

                    dispatch( 'orderTab/saveCurrentOrderSubmitted', JSON.parse( localStorage.getItem( 'cart' ) ), { root: true });
                    commit( 'removeOrderWasChanged' );
                    commit( 'setIsLoading', false );
                    commit( 'orderError', 'Payment failed. Please check your credit card information and try again' );

                } else if ( res.data.responseCode == 20917 ) { //Delivery Failed IHD 
                    commit( 'setIsLoading', false );
                    commit( 'orderError', null );
                    commit( 'clearTab' );
                    router.replace( { name : 'order-delivery-failure' } );
                } else if ( res.data.responseCode == 20916 ) { //Refund Failed Clover 
                    commit( 'setIsLoading', false );
                    commit( 'orderError', null );
                    commit( 'clearTab' );
                    router.replace( { name : 'order-delivery-failure' } );
                } else if ( res.data.responseCode == 20918 ) { //Duplicate Order
                    commit( 'setIsLoading', false );
                    commit( 'orderError', null );
                    commit( 'clearTab' );
                    router.replace( { name : 'order-duplicate-failure' } );
                } else {
                    commit( 'setIsLoading', false );
                    commit( 'orderError', 'We could not handle this request, please try again.' );
                }

            }).catch( err => {

                //commit( 'orderError', err );
                commit( 'orderError', 'We could not handle this request, please try again.' );
                commit( 'setIsLoading', false );
                dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
                console.log( 'error sending order!', err );
            });
        } else {

            commit( 'orderError', 'This location has been disabled for online orders!' );
            dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
        }
    },
    saveCloverOrderId({commit}, cloverOrderId){
        commit( 'saveCloverOrderId', cloverOrderId);
    },
    saveQuickOrderId({commit}, quickOrderId){
        commit( 'saveQuickOrderId', quickOrderId);
    },
    saveCurrentOrderSubmitted({commit}, orderCurrentCard){
        let orderCard = orderCurrentCard;
        commit( 'addCurrentOrderSubmitted', orderCard);
    },
    submitAgainPayment({commit, getters, dispatch, rootGetters}, encryptedPayment){
        
        if ( getters.orderWasChanged ) {
            console.log('Order was changed');
            dispatch( 'orderTab/submitOrder', encryptedPayment, { root : true });
        } else {

            console.log('Submiting again same clover order Id: ', getters.cloverOrderId);

            var deliveryFee = 0;
            var hasDelivery = 0;
            var uuid = JSON.parse( localStorage.getItem( 'activeOrder' ) ).uuid;

            let deliverySelected = JSON.parse( localStorage.getItem( 'DeliverySelected' ) );

            if ( deliverySelected !== null ) {

                let deliveryType = JSON.parse( localStorage.getItem( 'DeliverySelected' ) ).deliveryType;
                let fullDelivery = JSON.parse( localStorage.getItem( 'currentLocation' ) ).fullDelivery;

                if (deliveryType == 'FullDelivery' && fullDelivery !== false) {
                    console.log('Delivery Fee on submitAgainPayment');
                    hasDelivery = 1;
                    deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
                }
            }

            let newSubTotalBefore = parseFloat(encryptedPayment.subTotalBefore)
            let newSubTotalBeforeWithDelivery = newSubTotalBefore + parseFloat(deliveryFee) + parseFloat(getters.getDeliveryOtherFee)
            
            if ( parseInt( rootGetters[ 'merchant/currentLocation' ].acceptingOrders ) == 1 ) {

                commit( 'setIsLoading', true );

                axiosOrders({
                    method: 'post',
                    url: '/payOrder',
                    data: qs.stringify({

                        merchantId                  : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                        merchantLocationId          : rootGetters[ 'merchant/currentLocation' ].locationId,
                        payment                     : encryptedPayment.encryptedData,
                        tax                         : getters.getTax,
                        tip                         : state.orderTip,
                        subTotal                    : parseFloat(newSubTotalBeforeWithDelivery).toFixed(2),
                        externalOrderId             : getters.cloverOrderId,
                        internalOrderId             : getters.quickOrderId,
                        deliveryFee                 : deliveryFee,
                        uuid                        : uuid,
                        hasDelivery                 : hasDelivery,
                    })
                }).then( res => {

                    console.log('submitAgainPayment', res.data.responseCode);

                    if ( res.data.responseCode == 100 ) { // order worked

                        const merch = {

                            waitTime    : rootGetters[ 'merchant/currentLocation' ].waitTime,
                            phoneNumber : rootGetters[ 'merchant/currentLocation' ].phoneNumber
                        };
                        dispatch( 'merchant/updateCurrentLocationAfterOrder', merch, { root: true } );

                        commit( 'setIsLoading', false );
                        commit( 'orderError', null );
                        commit( 'clearTab' );
                        commit( 'thisOrderNumber', getters.cloverOrderId);
                        commit( 'removeCloverOrderId' );
                        state.cardsCached = null;
                        dispatch( 'orders/clearState', null, { root: true } );
                        dispatch( 'orderMenu/clearState', null, { root: true } );
                        dispatch( 'cards/cleanCards', null, { root: true } );
                        dispatch( 'orders/generateUuidOrder', null, { root: true } ).then( uuidOrder => {
                            console.log('uuidOrder in orderTab started again');
                            console.log(uuidOrder);
        
                            const order = {
                                uuid: uuidOrder,
                                deliveryFee: 0
                            };
        
                            dispatch( 'orders/setActiveOrder', order, { root: true } );
                        });
                        router.replace( { name : 'order-success' } );
                    
                    } else if ( res.data.responseCode == 20910 ) {

                        commit( 'setIsLoading', false );
                        commit( 'orderError', 'This order is not ready to be paid.');

                    } else if ( res.data.responseCode == 20911 ) {

                        commit( 'setIsLoading', false );
                        commit( 'orderError', 'Order has already been paid.');

                    } else if ( res.data.responseCode == 270 ) {

                        commit( 'setIsLoading', false );
                        commit( 'orderError', 'Order payment attempt failed.  Missing data.');

                    } else if ( res.data.responseCode == 20917 || res.data.responseCode == 20916 ) { //Delivery Failed IHD 
                        commit( 'setIsLoading', false );
                        commit( 'orderError', null );
                        commit( 'clearTab' );
                        router.replace( { name : 'order-delivery-failure' } );
                    } else if ( res.data.responseCode == 20918 ) { //Duplicate Order
                        commit( 'setIsLoading', false );
                        commit( 'orderError', null );
                        commit( 'clearTab' );
                        router.replace( { name : 'order-duplicate-failure' } );
                    } else {
                        commit( 'setIsLoading', false );
                        commit( 'orderError', 'Order payment attempt failed. Please check your credit card information and try again' );
                    }

                }).catch( err => {

                    //commit( 'orderError', err );
                    commit( 'setIsLoading', false );
                    commit( 'orderError', 'We could not handle this request, please try again.' );
                    dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
                });

            } else {

                commit( 'orderError', 'This location has been disabled for online orders!' );
                dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
            }

        }

    },
    toggleSaveCard( { commit } ){

        commit( 'toggleSaveCard' );
    },
    setTip( { commit, getters }, tipValue ){

        const currentCost = parseFloat( getters.getCost.toFixed( 2 ) );
        const newAmount = currentCost * tipValue;
        commit( 'updateTipValue', tipValue );
        commit( 'updateTip', newAmount );
        commit( 'setTipValue', newAmount );
    },
    toggleTab( { commit, dispatch, rootGetters } ){

        commit( 'toggleTab' );
        dispatch('cards/cleanCardsWithoutCurrent');

        let deliverySelected = JSON.parse( localStorage.getItem( 'DeliverySelected' ) );

        if ( deliverySelected !== null ) {
            let deliveryType = JSON.parse( localStorage.getItem( 'DeliverySelected' ) ).deliveryType;
            //console.log(deliveryType);

            let deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
            //console.log(deliveryFee);

            if ( deliveryFee == 0 && deliveryType == 'FullDelivery' ) {
                let deliverySelected = rootGetters['merchant/deliverySelected']
                console.log('deliverySelected')
                console.log(deliverySelected)

                const dataDelivery = {

                    deliveryType : 'FullDelivery',
                    addressOne : deliverySelected.addressOne,
                    addressTwo : deliverySelected.addressTwo,
                    addressCity : deliverySelected.addressCity,
                    addressState : deliverySelected.addressState,
                    addressZip : deliverySelected.addressZip,
                    addressCountry : 'US',
                    goToOrderTab : true
                };
                dispatch( 'merchant/getDeliveryFee', dataDelivery, { root: true } );
            } else {
                router.push( { name: 'order-tab' } );
            }
        } else {
            router.push( { name: 'order-tab' } );
        }

    },
    processPaymentInfo( { commit, getters, dispatch, rootGetters }, paymentResponse ){

        return new Promise( ( resolve, reject ) => {
            //console.log('original paymentResponse');
            //console.log(paymentResponse);
            const card = JSON.stringify( paymentResponse );
            const phrase = rootGetters[ 'publicKey' ];
            //console.log('json stringify reponse');
            //console.log(card);
            function encrypt( string, key ) {

                let crypt = new JSEncrypt();
                crypt.setPublicKey( key );
                let encryptedString = crypt.encrypt( string );
                return encryptedString;
            }

            for ( let key in paymentResponse ) {

                let payload = paymentResponse[ key ];
                paymentResponse[ key ] = encrypt( payload, phrase );
            }


            let encDetails = btoa( JSON.stringify( paymentResponse ) );
            if( encDetails ) resolve( encDetails );
            else reject( 'error with card encryption, tell erik so this doesn\'t go to production!' );
        });
    },
    toggleSaveCard( { commit } ){

        commit( 'toggleSaveCard' );
    },
    updateNote( { commit }, value ){

        localStorage.setItem( 'updateNote', JSON.stringify( value ) );
        commit( 'updateNote', value );
    },
    checkAgainstNewMenu( { commit, getters }, newMenu ){

        // console.log( 'checking tab against new menu..', newMenu );
        let newTab = [ ...getters.currentTab ];
        newTab.forEach( tabItem => {

            // console.log( 'tabItem: ', tabItem );
            let newItems = Object.values( newMenu[ 'Items' ] );
            for( let i = 0; i < newItems.length; i++ ){

                // console.log( 'Going through a new Item..' );
                if( newItems[ i ].QuickItem.quickItemId == tabItem.quickItemId ){

                    // console.log( 'Found tabItem within menu data: ', newItems[ i ] );
                    if( [ null, 'null', '', '0', 0 ].includes( newItems[ i ].QuickItem.available ) ){
                        // item no longer available

                        // console.log( 'item is in list but marked unavailable..' );
                        tabItem.available = 0;
                        tabItem.reason = 'Item no longer available';
                    } else if( tabItem.available == 0 && [ true, 'true', '1', 1 ].includes( newItems[ i ].QuickItem.available ) ){

                        // console.log( 'tabItem was made available again' );
                        delete tabItem.available;
                        delete tabItem.reason;
                    }

                    // console.log( 'item found in list, availability is resolved..' );
                    if( tabItem.available != 0 && tabItem.modifiers.length > 0 ) {
                        // availability for the item itself resolved, check modifiers *if there are any*

                        // console.log( 'Checking item modifiers for availability..' );
                        let newMods = Object.values( newMenu[ 'ModifierGroups' ] );
                        // console.log( 'new modifier list: ', newMods );
                        for( let j = 0; j < tabItem.modifiers.length; j++ ){ // go through each tab-item modifier

                            let modArray = tabItem.modifiers[ j ].split( '_' );
                            // console.log( 'tabItem modifier: ', modArray );
                            for( let k = 0; k < newMods.length; k++ ){ // find the group it belongs to

                                if( modArray[ 1 ] == newMods[ k ][ 'QuickModifierGroup' ][ 'quickModifierGroupId' ] ){
                                    // find the modifier it lines up with

                                    let matchedModifier = Object.values( newMods[ k ][ 'QuickModifier' ] ).filter( mod => mod.quickModifierId == modArray[ 3 ] );
                                    // console.log( 'matched modifier: ', matchedModifier );
                                    if( [ null, 'null', '', '0', 0 ].includes( matchedModifier[ 0 ].available ) ){

                                        // console.log( 'this modifier is now marked unavailable' );
                                        modArray[ modArray.length ] = 'unavailable';
                                        tabItem.modifiers[ j ] = modArray.join( '_' );
                                    } else if( modArray[ modArray.length - 1 ] == 'unavailable' && [ true, 'true', '1', 1 ].includes( matchedModifier[ 0 ].available ) ){

                                        // console.log( 'modifier was previously unavailable but made available now..' );
                                        modArray.pop();
                                        tabItem.modifiers[ j ] = modArray.join( '_' );
                                    }
                                    break;
                                }

                                if( k == newMods.length - 1 ){

                                    // console.log( 'modifier made it to end: ', tabItem.modifiers[ j ] );
                                    // console.log( 'item has a modifier that is no longer listed' );
                                    modArray[ modArray.length ] = 'unavailable';
                                    tabItem.modifiers[ j ] = modArray.join( '_' );
                                }
                            }
                        }
                    }

                    break; // matched the item and resolved it's availability state, break and begin searching the next item
                }

                if( i == newItems.length - 1 ){

                    // console.log( 'tabItem made it to end: ', tabItem );
                    // console.log( 'item must not be in the list anymore..' );
                    tabItem.available = 0; // item wasn't found, no longer offered
                    tabItem.reason = 'Item no longer available';
                }
            }
        });
        commit( 'updateTab', newTab );
    },
    isOrderWasChanged({commit, getters}){

        let cardOrder = getters.currentTab;
        let cardOrderRecurrent = getters.currentOrderSubmitted;

        console.log('cardOrderRecurrent', cardOrderRecurrent.length);

        var quickItemIds = [];

        cardOrderRecurrent.forEach( tabItem => {
            console.log(tabItem);
            quickItemIds.push(tabItem.quickItemId);
        });

        console.log('quickItemIds array => ', quickItemIds);

        console.log('cardOrder', cardOrder.length);
        
        if (cardOrder.length !== cardOrderRecurrent.length) {
            commit( 'setOrderWasChanged' );
        } else {
            cardOrder.forEach( tabItem => {
                console.log(tabItem);
                if (quickItemIds.indexOf(tabItem.quickItemId) <= -1) {
                    console.log('This item id: ' + tabItem.quickItemId + ' NO FOUND IT... ');
                    commit( 'setOrderWasChanged' );
                }
            });
        }
    }
};

const getters = {

    getCost( state ){

        return state.currentTab.reduce( ( totalTicketAmount, item ) => {

            return item.available == 0 ? totalTicketAmount : totalTicketAmount + parseFloat( item.price );
        }, 0.00 );
    },
    getCostAfterBonusCard(state, getters) {
        let subTotal = getters.getCost;
        console.log("subTotal get", subTotal);
        let promotionCard = getters.getPromotionCard;
        console.log("promotionCard get", promotionCard);

        return parseFloat(state.currentTab.reduce((totalTicketAmount, item) => {
            let discount = ((parseFloat(item.price) * promotionCard) / subTotal);
            return item.available == 0 || promotionCard >= subTotal ? totalTicketAmount : totalTicketAmount + (parseFloat(item.price) - discount);
        }, 0.00)).toFixed(2);
    },
    getTax( state, getters ){

        if( state.currentTab.length < 1 ) return 0;
        else {
            //console.log("impuestos");
            //console.log(Object.values(state.currentTab));
            let deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
            console.log(deliveryFee);
            let subTotal = getters.getCost + parseFloat(deliveryFee);
            //console.log("subTotal", subTotal);
            let promotionCard = getters.getPromotionCard;
            //console.log("promotionCard", promotionCard);
            return Object.values( state.currentTab ).reduce( ( totalTax, item ) => {
                let split = ((parseFloat(item.price) * promotionCard) / subTotal);
                return item.taxRate == null || promotionCard >= subTotal ? totalTax : totalTax + ( (parseFloat( item.price ) - split) * ( parseFloat( item.taxRate ) / 100 ) )
            }, 0.00).toFixed(2);
        }
    },
    getPromotionCard(state, getters, rootState, rootGetters ) {
        //console.log("rootgetersmerchant",rootGetters['cards/currentCard']);
        if (rootGetters['cards/currentCard'] != null ){
            if (rootGetters['merchant/currentMerchant'].merchantId == rootGetters['cards/currentCard'].Merchant.merchantId ) {
                if (parseFloat(rootGetters['cards/currentCard'].PrepaidAccount.balance) >= parseFloat(rootGetters['orderTab/getCost'])) {
                    //console.log("im sending", parseFloat(rootGetters['orderTab/getCost']));
                    return parseFloat(rootGetters['orderTab/getCost']);
                } else {

                    return parseFloat(rootGetters['cards/currentCard'].PrepaidAccount.balance);
                }
            } else {
                return 0.00;
            }

        } else {
            return 0.00;
        }

    },
    orderTip : state => parseFloat( state.orderTip ).toFixed( 2 ),
    tabOpen( state, getters, rootGetters ){

        if(
            state.currentTab.length >= 1
            && ![ 'order-tab', 'payment', 'payment-card' ].includes( rootGetters[ 'currentRoute' ].name )
        ) return true;
        return false;
    },
    orderTotal(state, getters){
        console.log(state.delivery.deliveryType);        
        console.log("refreshing orderTotal...");
        let deliverySelected = JSON.parse( localStorage.getItem( 'DeliverySelected' ) );

        if ( deliverySelected !== null ) {
            console.log("refreshing page with deliverySelected true case");
        
            let deliveryType = JSON.parse( localStorage.getItem( 'DeliverySelected' ) ).deliveryType;
            let fullDelivery = JSON.parse( localStorage.getItem( 'currentLocation' ) ).fullDelivery;

            if (deliveryType == 'FullDelivery' && fullDelivery !== false) {
                console.log('Delivery Fee on orderTotal=>');
                let deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
                console.log(getters.getDeliveryOtherFee);
                return (parseFloat(getters.getTax) + parseFloat(getters.getDeliveryOtherFee) + getters.getCost + parseFloat(deliveryFee) + parseFloat(getters.orderTip) - getters.getPromotionCard  ).toFixed( 2 );
            }
        }
        return (parseFloat(getters.getTax) + getters.getCost + parseFloat(getters.orderTip) - getters.getPromotionCard  ).toFixed( 2 );
        
    },
    orderError              : state => state.orderError,
    currentTab              : state => state.currentTab,
    saveCard                : state => state.saveCard,
    cloverOrderId           : state => state.cloverOrderId,
    quickOrderId            : state => state.quickOrderId,
    currentOrderSubmitted   : state => state.currentOrderSubmitted,
    orderNote               : state => state.orderNote == '' ? '' : JSON.parse( localStorage.getItem( 'updateNote' ) ),
    tipValue                : state => state.tipValue,
    tip                     : state => state.tip,
    thisOrderNumber         : state => state.thisOrderNumber,
    thisInternalOrderNumber : state => state.thisInternalOrderNumber,
    orderWasChanged         : state => state.orderWasChanged,
    isLoadingOrder          : state => state.isLoading,
    getDeliveryFee          : state => state.deliveryFee,
    getDeliveryOtherFee     : state => state.otherFees            
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
